import { RESOURCE_NOT_FOUND_TYPE, ResponseError } from "../defaults";

export const isResourceNotFoundError = (error: unknown) =>
    error instanceof ResponseError && error.status === 404 && error.problem?.type === RESOURCE_NOT_FOUND_TYPE;
